import { ThemeProvider, createTheme } from '@mui/material/styles'

const MuiThemeInjector = ({ theme, children }) => {
  if (!theme) {
    return children
  }
  const muiTheme = createTheme(theme)
  return <ThemeProvider theme={muiTheme}>{children}</ThemeProvider>
}

export default MuiThemeInjector
